import moment from 'moment';

const OrgPaidStatus = function() {
  const isOrgPremium = org => {
    const { license = {} } = org;
    const { planType, trialEndDate } = license;

    return planType === 'ENTERPRISE' || (planType === 'PRO' && !trialEndDate);
  };

  // See https://github.com/sourceclear/platform-frontend/pull/648
  const isOrgTrialing = org => {
    const { license = {} } = org;
    const { trialEndDate } = license;

    // Cater for the case where new orgs will have a null value
    // for trialEndDate when it has ended
    // Handle case 4
    if (!!trialEndDate === false) {
      return false;
    }

    // At this point trialEndDate has a value, it happens for
    //  - legacy org who would always have a trialEndDate
    //  - new org who has a trialEndDate set
    // Handle cases 1, 2 and 3.
    return moment().isBefore(trialEndDate);
  };

  const isOrgPaidOrTrial = (org = {}) => {
    return isOrgTrialing(org) || isOrgPremium(org);
  };

  const isOrgAbleToTrial = (org = {}) => {
    const { license = {} } = org;

    return license.canTrial;
  };

  const calculateDaysLeft = endDate => {
    if (!endDate || isNaN(endDate.unix())) {
      return 0;
    }

    const oneDay = 24 * 60 * 60 * 1000;
    const todayDate = moment();
    const diffInMilliseconds = todayDate.diff(endDate);

    return Math.round(Math.abs(diffInMilliseconds / oneDay));
  };

  return {
    isOrgPaidOrTrial,
    isOrgAbleToTrial,
    calculateDaysLeft,
  };
};

export default new OrgPaidStatus();
